import {Accordion, AccordionSummary, AccordionDetails, Chip, LinearProgress, Stack, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Constants from "../../../../utils/constants.js";
import TourneeStatutBadge from "./TourneeStatutBadge.js";
import TourneeCard from "./TourneeCard.js";
import HeureDebutChip from "./HeureDebutChip.js";
import {dashboardHelper} from "../utils/dashboardHelper.js";
import {useTheme} from '@mui/material/styles';

function TourneeAccordion({data, selectedDate, onTourneeDetailClick, onTourneeImpossibleClick}) {
    const theme = useTheme();

    return (
        <Accordion sx={{border: '1px solid lightgray'}}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <Stack direction="row" spacing={2}
                       sx={{width: '100%', justifyContent: 'space-between', paddingRight: '2rem'}}>

                    <Stack direction="row" spacing={2} alignItems="center">
                        <TourneeStatutBadge
                            totalALaver={data.totalALaver}
                            totalBacsLaves={data.totalBacsLaves}
                            totalBacsImpossible={data.totalBacsImpossible}
                        />
                        <Typography variant="h5">{data.libelle}</Typography>
                        <HeureDebutChip heureDebut={data.heureDebut}/>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                        <Chip label={data.equipe.label}
                              sx={{
                                  backgroundColor: data.equipe.color,
                                  color: theme.palette.getContrastText(data.equipe.color),
                                  fontWeight: 'bold'
                              }}
                        />
                        <Chip label={`${data.totalALaver} bacs prévus`}
                              sx={{backgroundColor: Constants.COLOR_THEME_BLUE, color: "white"}}/>
                        <Chip label={`${data.totalBacsLaves} lavé(s)`}
                              sx={{backgroundColor: Constants.COLOR_THEME_GREEN, color: "white"}}/>
                        {data.totalBacsImpossible > 0 &&
                            <Chip label={`${data.totalBacsImpossible} impossible(s)`}
                                  sx={{backgroundColor: Constants.COLOR_THEME_RED, color: "white"}}/>
                        }
                    </Stack>
                </Stack>

                <LinearProgress
                    variant="determinate"
                    value={dashboardHelper.getClientProgress(data)}
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '4px',
                        backgroundColor: '#e0e0e0',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: Constants.COLOR_THEME_GREEN,
                        },
                    }}
                />
            </AccordionSummary>

            <AccordionDetails>
                <TourneeCard
                    data={data}
                    selectedDate={selectedDate}
                    onTourneeDetailClick={onTourneeDetailClick}
                    onTourneeImpossibleClick={onTourneeImpossibleClick}
                />
            </AccordionDetails>
        </Accordion>
    )
}

export default TourneeAccordion;
